import { render, staticRenderFns } from "./pointsDetails.vue?vue&type=template&id=741b5f76&scoped=true&"
import script from "./pointsDetails.vue?vue&type=script&lang=ts&"
export * from "./pointsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./pointsDetails.vue?vue&type=style&index=0&id=741b5f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741b5f76",
  null
  
)

export default component.exports